import { l as languages } from "../../index-bkac8M6P.js";
import { a as addJsxTag } from "../../jsx-shared-Bxuvc7gd.js";
import "./javascript.js";
addJsxTag(languages.js, "jsx");
//# sourceMappingURL=jsx.js.map
